module.exports = __webpack_public_path__ + "static/media/Krish-e-Purple.9dff47ad.png";